{
  "id": "campaign-129",
  "name": "Shaggy Stadium",
  "seed": "campaign:129",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r,,,,,QQQQ,,~,,r",
    ",,,:,,,,,,,~:~,,",
    ",,,:,a,,,,a,:,x,",
    ",,,::::::::::,,,",
    ",a,,...,,,,,,,a,",
    ",,a,a..,,,,a,a,,",
    ",,,,...,,,,,,,,,",
    ",,a,,,,,,,,..a,,",
    "::::::::::::::::",
    ",,,,,,,,,,.....,",
    "~~~,,,,,,,.....,",
    ".~,,,,a,,a,...,,",
    ",,,,,a,,,.a.,,,,",
    ",,,::::::::::,,,",
    ",,,:,,a,.a..:,,,",
    "..x:x,,,....:,..",
    "S...,,QQQQ......"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 15,
      "y": 15
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 3
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 8
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 13
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 2,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 2
    },
    {
      "kind": "gas",
      "x": 13,
      "y": 14
    },
    {
      "kind": "gas",
      "x": 12,
      "y": 6
    },
    {
      "kind": "gas",
      "x": 14,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 5
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "balls": {
    "first": 18,
    "every": 14
  },
  "generatorVersion": 3,
  "level": 129,
  "biome": "stadium",
  "par": {
    "reel": 10468,
    "push": 8977,
    "selfPropelled": 8295,
    "tractor": 6914,
    "zeroTurn": 5959,
    "fairway": 3844
  },
  "goldTime": {
    "reel": 10123,
    "push": 8782,
    "selfPropelled": 8148,
    "tractor": 6591,
    "zeroTurn": 5814,
    "fairway": 3703
  },
  "routeTries": {
    "par": {
      "reel": 4,
      "push": 0,
      "selfPropelled": 12,
      "tractor": 3,
      "zeroTurn": 0,
      "fairway": 24
    },
    "gold": {
      "reel": 44,
      "push": 33,
      "selfPropelled": 49,
      "tractor": 25,
      "zeroTurn": 44,
      "fairway": 46
    }
  }
}
